import { useCallback, useEffect, useState } from "react";
import { AiCampaignProgressEvent } from "@/model/interface/Campaign";
import { useSocketSubscription } from "@/hooks/useSocketSubscription";

export function useAiCampaignSocket(campaignId: string | null) {
  const [events, setEvents] = useState<Record<string, AiCampaignProgressEvent>>({});

  const reset = useCallback(() => setEvents({}), []);

  useEffect(() => {
    setEvents({});
  }, [campaignId]);

  useSocketSubscription(campaignId ? `/topic/ai-campaign/${campaignId}` : null, (message) => {
    try {
      const event = JSON.parse(message.body) as AiCampaignProgressEvent;
      setEvents((previous) => ({ ...previous, [event.contactId]: event }));
    } catch (parseError) {
      console.error("Failed to parse AI campaign event", parseError);
    }
  });

  return { events, reset };
}
